import React from 'react';
import { bool, node, number, oneOfType, string } from 'prop-types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { border, color, display, sizing, spacing } from '@/components/styled-system';

const StyledContainer = styled.div`
  ${({ scrollable }) => css`
    width: 100%;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;

    ${scrollable === true && 'overflow: auto;'};
    ${scrollable === 'x' && 'overflow-x: auto;'};
    ${scrollable === 'y' && 'overflow-y: auto;'};
  `}
  ${color};
  ${display};
  ${sizing};
  ${spacing};
  ${border};
`;

/**
 * Container Component
 * @typedef {{
 * children: React.ReactNode,
 * scrollable: boolean|string }
 * & import('../../styled-system').BorderProps
 * & import('../../styled-system').ColorProps
 * & import('../../styled-system').SizingProps
 * & import('../../styled-system').SpacingProps
 * & import('../../styled-system').DisplayProps} ContainerProps
 * @type {React.FC<ContainerProps>}
 * @returns
 */
const Container = ({ children, ...props }) => (
  <StyledContainer {...props}>{children}</StyledContainer>
);

Container.defaultProps = {
  children: node,
  padding: '0px 16px',
  scrollable: false,
};

Container.propTypes = {
  children: null,
  padding: oneOfType([string, number]),
  scrollable: oneOfType([bool, string]),
};

export default Container;
